import { render, staticRenderFns } from "./loginAuthOther.vue?vue&type=template&id=0a3e0cfa&scoped=true&"
import script from "./loginAuthOther.vue?vue&type=script&lang=js&"
export * from "./loginAuthOther.vue?vue&type=script&lang=js&"
import style0 from "./loginAuthOther.vue?vue&type=style&index=0&id=0a3e0cfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3e0cfa",
  null
  
)

export default component.exports